import { render, staticRenderFns } from "./AccountStatisticCUASummary.vue?vue&type=template&id=062f4e41"
import script from "./AccountStatisticCUASummary.vue?vue&type=script&lang=js"
export * from "./AccountStatisticCUASummary.vue?vue&type=script&lang=js"
import style0 from "./AccountStatisticCUASummary.vue?vue&type=style&index=0&id=062f4e41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports